import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { DebugFlagsService } from '../services';
import { enableDisableView } from './directive-helpers';

@Directive({
  selector: '[appIfDebugFlag]'
})
export class IfDebugFlagDirective {
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private debugFlagService: DebugFlagsService
  ) {}

  @Input()
  set appIfDebugFlag(flagName: string) {
    this.hasView = enableDisableView(
      this.debugFlagService.hasDebugFlag(flagName),
      this.viewContainer,
      this.templateRef,
      this.hasView
    );
  }
}
